import React, { useEffect, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import AddIco from "../Components/Images/plus-add-ico.svg";
import SeacrhIco from "../Components/Images/search-ico.svg";
import Datatable from '../Components/Datatable/Datatable';
import { Link } from 'react-router-dom';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import Loader from '../Components/Layout/Loader';

export default function Locations() {

    const [advList, setAdvList] = useState([]);
    const [searchparams, set_searchparams] = useState("");
    const [pagination, set_pagination] = useState({
        page: 1,
        sizePerPage: 10
    });
    const [loader, set_loader] = useState(false);

    const columnList = ["Locality", "City", "District", "State", "Pincode"]

    useEffect(() => {
        set_loader(true);
        getAdvList();
    }, [])

    const getAdvList = () => {
        const query = {
            "page": pagination.page,
            "sizePerPage": pagination.sizePerPage,
            "searchparams": searchparams
        }
        const FeaturedAdvData = Promise.resolve(PostApiWithoutLogin(API_PATH.GetLocations, query));
        FeaturedAdvData.then(response => {
            if(response.status === 200) format_data(response.data?.data?.locations ?? []);
            else setAdvList([]);
            set_loader(false);
        })
    }

    const format_data = (data) => {
        if(data.length > 0) {
            let formated_data = [];
            data.forEach(item => {
                let formated_item = {
                    "id": item._id ?? "-",
                    "Locality": item.PostOfficeName ?? "-",
                    "City": item.City ?? "-",
                    "District": item.District ?? "-",
                    "State": item.State ?? "-",
                    "Pincode": item.Pincode ?? "-",
                }
                formated_data.push(formated_item);
            })
            setAdvList(formated_data);
        } else setAdvList([]);
    }
 

    return (
        <Layout>
            {loader === true ? <Loader></Loader> : <></>}
            <div className="nav-top-section">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12 mt-3">
                            <div className="bx-white-main">
                                <div className="d-flex align-items-center">
                                    <div className="ms-auto d-flex flex-column-reverse">
                                        <div className='m-2 d-flex'>
                                            <div className="position-relative src-hdr-tops m-0">
                                                <img src={SeacrhIco} loading="lazy" alt="" />
                                                <input type="search" onChange={(e) => set_searchparams(e.target.value)} className="form-control form-style-input" placeholder="Search Location" />
                                            </div>
                                            <div onClick={() => getAdvList()} className="btn-all-comn d-flex justify-content-center align-items-center ml-2">
                                                Search
                                            </div>
                                        </div>
                                        <div className="m-2">
                                            <Link to="/add-new-location" className="btn-all-comn d-flex justify-content-center align-items-center">
                                                <img src={AddIco} className="me-2" loading="lazy" alt="" />
                                                Add New Location
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                                <div className="pt-2 mt-1">
                                    <Datatable column={columnList} data={advList} pagination={pagination} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}